import React from "react";
import { apiRequest } from "../../../utils/api_service";
import { API_URL } from "../../../constants/api";
import RenderChart from "../../common/Chart/RenderChart";
import { getChartData } from "../../../utils/graph_service";
import {
  AppBar,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Toolbar,
  Tooltip,
  Typography
} from "@material-ui/core";
import DenseTable from "../../Dashboard/RenderTable";
import { InfoOutlined } from "@material-ui/icons";
import VisibilityIcon from "@material-ui/icons/Visibility";
import {
  GetSectionPermission,
  getSynchStatus,
  PaperComponent
} from "../../../utils/helper";
import { SECTIONS } from "../../../constants/appConstants";
import Skeleton from "@material-ui/lab/Skeleton";
import { IoMdCloseCircleOutline } from "react-icons/io";
const CData = [
  { key: "WorkOrderId", name: "Work Order Id" },
  { key: "JobType", name: "Job Type" },
  { key: "AssetId", name: "Asset Id" },
  { key: "JobPriority", name: "Job Priority" },
  { key: "Name", name: "Name" },
  { key: "ReceivedDate", name: "Received Date", format: "DateTime" },
  { key: "DueDate", name: "Due Date", format: "DateTime" },
  { key: "ClosedDate", name: "Closed Date", format: "DateTime" },
  { key: "Requestor", name: "Requestor" },
  { key: "ServiceLocation", name: "Service Location" },
  {
    key: "PrivateNote",
    name: "Private Note",
    clickable: true
  },
  {
    key: "PublicNote",
    name: "Public Note",
    clickable: true
  },
  { key: "Type", name: "Type" },
  { key: "WorkOrderStatus", name: "Status" },
  { key: "ServiceDescription", name: "Description", width: 450 },
  { key: "Source", name: "Source" }
];

const configData = {
  trend: {
    type: "Month",
    key: "ReceivedDate"
  },
  columns: [
    {
      key: "",
      name: "Incident - High",
      type: "count",
      filters: [
        {
          key: "JobType",
          values: ["Incident - High"]
        }
      ],
      color: "#E59400",
      sortOrder: 0
    },
    {
      key: "",
      name: "Incident - Medium",
      type: "count",
      filters: [
        {
          key: "JobType",
          values: ["Incident - Medium"]
        }
      ],
      color: "#007300",
      sortOrder: 1
    },
    {
      key: "",
      name: "Incident - Low",
      type: "count",
      filters: [
        {
          key: "JobType",
          values: ["Incident - Low"]
        }
      ],
      color: "#1A8FBF",
      sortOrder: 2
    }
  ]
};

const configData2 = {
  trend: {
    type: "Month",
    key: "ReceivedDate"
  },
  columns: [
    {
      key: "",
      name: "Unsafe Condition",
      type: "count",
      filters: [
        {
          key: "JobType",
          values: ["Unsafe Condition"]
        }
      ],
      color: "#E59400",
      sortOrder: 0
    },
    {
      key: "",
      name: "Unsafe Act",
      type: "count",
      filters: [
        {
          key: "JobType",
          values: ["Unsafe Act"]
        }
      ],
      color: "#007300",
      sortOrder: 1
    },
    {
      key: "",
      name: "Near Miss",
      type: "count",
      filters: [
        {
          key: "JobType",
          values: ["Near Miss"]
        }
      ],
      color: "#1A8FBF",
      sortOrder: 2
    },
    {
      key: "",
      name: "Recordable Incidents",
      type: "count",
      filters: [
        {
          key: "JobType",
          values: ["HSE - Recordable Incident"]
        }
      ],
      color: "#bf1a1a",
      sortOrder: 2
    },
    {
      key: "",
      name: "Non - Recordable Incidents",
      type: "count",
      filters: [
        {
          key: "JobType",
          values: ["HSE - Non-Recordable Incident"]
        }
      ],
      color: "#1d4ec2",
      sortOrder: 2
    }
  ]
};

const configData3 = {
  trend: {
    type: "Month",
    key: "ReceivedDate"
  },
  columns: [
    // {
    //   key: "",
    //   name: "Scheduled Physical Patrols",
    //   type: "count",
    //   filters: [
    //     {
    //       key: "JobType",
    //       values: ["Security - Physical Tour"],
    //     },
    //     {
    //       key: "WorkOrderStatusId",
    //       values: [1, 2, 5, 6, 7, 8, 9],
    //     },
    //   ],
    //   color: "#1BBC86",
    //   sortOrder: 0,
    // },
    {
      key: "",
      name: "Completed Physical Patrols",
      type: "count",
      filters: [
        {
          key: "JobType",
          values: ["Security - Physical Tour"]
        },
        {
          key: "WorkOrderStatusId",
          values: [3, 4]
        }
      ],
      color: "#2D76E5",
      sortOrder: 1
    },
    // {
    //   key: "",
    //   name: "Scheduled Virtual Patrols",
    //   type: "count",
    //   filters: [
    //     {
    //       key: "JobType",
    //       values: ["Security - Virtual Tour"],
    //     },
    //     {
    //       key: "WorkOrderStatusId",
    //       values: [1, 2, 5, 6, 7, 8, 9],
    //     },
    //   ],
    //   color: "#7F40D1",
    //   sortOrder: 1,
    // },
    {
      key: "",
      name: "Completed Virtual Patrols",
      type: "count",
      filters: [
        {
          key: "JobType",
          values: ["Security - Virtual Tour"]
        },
        {
          key: "WorkOrderStatusId",
          values: [3, 4]
        }
      ],
      color: "#92661a",
      sortOrder: 1
    }
  ]
};

let settingContainer;
class HealthAndSeftyGrphChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      IncidentReportsData: undefined,
      rawData: [],
      SortedRawData: [],
      IsConditionOpen: false,
      FiltersView: false,
      syncStatus: "NA"
    };
  }

  componentDidMount() {
    this.GetIncidentReportsData(
      this.props.propertyId,
      this.props.startDate,
      this.props.endDate
    );

    if (this.props.conf == 1) {
      settingContainer = configData;
    } else if (this.props.conf == 2) {
      settingContainer = configData2;
    } else if (this.props.conf == 3) {
      settingContainer = configData3;
    }
    this.getPatrolCount(
      this.props.propertyId,
      this.props.startDate,
      this.props.endDate
    );
  }

  componentWillReceiveProps(newProps) {
    if (
      newProps.propertyId != this.props.propertyId ||
      newProps.startDate != this.props.startDate ||
      newProps.endDate != this.props.endDate ||
      newProps.typeOfDate != this.props.typeOfDate ||
      newProps.toUpdateGraph != this.props.toUpdateGraph
    ) {
      this.getPatrolCount(
        newProps.propertyId,
        newProps.startDate,
        newProps.endDate
      );
      this.GetIncidentReportsData(
        newProps.propertyId,
        newProps.startDate,
        newProps.endDate,
        newProps.typeOfDate
      );
    }
  }

  /** Incident report data */
  GetIncidentReportsData = (propertyId, startDate, endDate, typeOfDate) => {
    const typeOfDateNew = typeOfDate;
    const params = {
      propertyId: propertyId,
      startDate: startDate,
      endDate: endDate
    };
    // console.log("Chart", params);
    apiRequest({
      url: API_URL.dashBoard.MaintenanceDetailsByDate,
      params
    }).then(({ data: IncidentReports, syncStatus: syncStatus }) => {
      let responseData;
      if (this.props.conf == 1) {
        responseData = getChartData(
          IncidentReports,
          configData,
          startDate,
          endDate,
          typeOfDateNew
        );
      } else if (this.props.conf == 2) {
        responseData = getChartData(
          IncidentReports,
          configData2,
          startDate,
          endDate,
          typeOfDateNew
        );
      } else if (this.props.conf == 3) {
        responseData = getChartData(
          IncidentReports,
          configData3,
          startDate,
          endDate,
          typeOfDateNew
        );
      }

      this.setState({
        IncidentReportsData: responseData,
        rawData: IncidentReports,
        startDate,
        endDate,
        syncStatus: ((syncStatus || [])[0] || {}).SyncStatus
      });
    });
  };

  /** key value data */
  getKeyValueData = (data, configuration, withPercent) => {
    const resData = [];
    let totalCount = 0;
    const colors = [];
    const columns = configuration.columns;
    columns.map((item,index) => {
      const filters = item.filters;
      let count = 0;
      const columnData = data;
      filters.forEach(element => {
        const result = columnData.filter(function(v) {
          return (
            v[element.key] ==
            element.values.find(value => value == v[element.key])
          );
        });
        count = count + (result || []).length;
      });
      totalCount += count;
      const color = item.color || colors[index];
      colors.push(color);
      resData.push({ attributeValue: count, attributeName: item.name });
    });
    if (withPercent) {
      for (let i = 0; i < resData.length; i++) {
        resData[i].percentage = Math.round(
          (resData[i].attributeValue / totalCount) * 100
        );
      }
      return { data: resData, colors: colors };
    }
    return resData;
  };

  /** Details by attribute and type */
  getDetailByAttributeAndType = () => {
    let FilterKeys;
    const RawData = [];
    const SortedRawData = this.state.rawData;
    if (this.props.conf == 1) {
      FilterKeys = ["Incident - High", "Incident - Medium", "Incident - Low"];
    } else if (this.props.conf == 2) {
      FilterKeys = [
        "Unsafe Condition",
        "Unsafe Act",
        "Near Miss",
        "HSE - Recordable Incident",
        "HSE - Non-Recordable Incident"
      ];
    } else if (this.props.conf == 3) {
      FilterKeys = [
        // {
        //   JobType: "Security - Physical Tour",
        //   Title: "Scheduled Physical Patrols",
        //   type: 0,
        // },
        {
          JobType: "Security - Physical Tour",
          Title: "Completed Physical Patrols",
          type: 1
        },
        // {
        //   JobType: "Security - Virtual Tour",
        //   Title: "Scheduled Virtual Patrols",
        //   type: 0,
        // },
        {
          JobType: "Security - Virtual Tour",
          Title: "Completed Virtual Patrols",
          type: 1
        }
      ];
    }
    let outPut;
    FilterKeys.map(item => {
      if (this.props.conf != 3) {
        outPut = SortedRawData.filter(value => value.JobType == item);
        RawData.push({ type: outPut, title: item });
      } else {
        if (item.type == 1) {
          outPut = SortedRawData.filter(
            value =>
              value.JobType == item.JobType &&
              (value.WorkOrderStatusId == 3 || value.WorkOrderStatusId == 4)
          );
          RawData.push({ type: outPut, title: item.Title });
        } else {
          outPut = SortedRawData.filter(
            value =>
              value.JobType == item.item &&
              (value.WorkOrderStatusId !== 3 || value.WorkOrderStatusId !== 4)
          );
          RawData.push({ type: outPut, title: item.Title });
        }
      }
    });

    // console.log(RawData);

    this.setState({
      SortedRawData: RawData,
      IsConditionOpen: true,
      FiltersView: false,
    });
  };

  /** Patrols count */
  getPatrolCount = (propertyId, startDate, endDate) => {
    const params = {
      propertyId: propertyId,
      startDate: startDate,
      endDate: endDate
    };
    apiRequest({
      url: API_URL.GuardForcePatrolSummary.GetGuardForcePatrolSummaryByDate,
      params
    }).then(({ data: StaffingSummary }) => {
      // console.log("---", StaffingSummary);
      this.setState({
        VirtualPatrol: (StaffingSummary[2] || {}).attributeValue || 0,
        PhysicalPatrol: (StaffingSummary[0] || {}).attributeValue || 0
      });
    });

    // let SortedRawData = this.state.rawData;
    // let outPut;
    // outPut = SortedRawData.filter(
    //   (value) =>
    //     value.JobType == JobTypeValue &&
    //     (value.WorkOrderStatusId == 3 || value.WorkOrderStatusId == 4)
    // );

    // return outPut.length;
  };

  render() {
    const {
      IncidentReportsData,
      SortedRawData,
      IsConditionOpen,
      FiltersView
    } = this.state;

    const permission = GetSectionPermission(
      SECTIONS.HEALTH_AND_SAFETY,
      SECTIONS.HEALTH_AND_SAFETY_NEAR_MISS
    );
    const ShowData = permission.showData;
    return (
      <>
        <div>
          <div className={"w-100  graph-title-hAnds"}>
            <div className={"w-50 pt-5 "}>
              {this.props.conf == 1
                ? "Operational Incidents"
                : this.props.conf == 2
                ? "Health & Safety / Near Miss"
                : "Guard-Force Patrols"}
            </div>
            {ShowData && (
              <div className={"w-50"} style={{ textAlign: "right" }}>
                <Tooltip title={"View Filters"}>
                  <IconButton
                    size={"small"}
                    onClick={() =>
                      this.setState({
                        IsConditionOpen: true,
                        FiltersView: true,
                      })}
                  >
                    <InfoOutlined size={"small"} fontSize={"small"} />
                  </IconButton>
                </Tooltip>
                <Tooltip title={"View Data"}>
                  <IconButton
                    size={"small"}
                    onClick={this.getDetailByAttributeAndType}
                  >
                    <VisibilityIcon size={"small"} fontSize={"small"} />
                  </IconButton>
                </Tooltip>
              </div>
            )}
          </div>
        </div>
        <div>
          {this.props.conf == 3 ? (
            <div className={"w-100 d-flex guard-force-titles"}>
              <div className={"w-50 tc"}>
                {"Total Scheduled Physical Patrols:"}{" "}
                {this.state.PhysicalPatrol == null ||
                this.state.PhysicalPatrol == 0
                  ? "-"
                  : this.state.PhysicalPatrol}
              </div>
              <div className={"w-50 tc"}>
                {"Total Scheduled Virtual Patrols:"}{" "}
                {this.state.VirtualPatrol == null ||
                this.state.VirtualPatrol == 0
                  ? "-"
                  : this.state.VirtualPatrol}
              </div>
            </div>
          ) : null}
        </div>
        <div id={this.props.reference + "container"}>
          {IncidentReportsData ? (
            <RenderChart
              identifier={this.props.reference}
              chartConfig={{
                startDate: this.state.startDate,
                endDate: this.state.endDate,
                configuration: this.state.config,
                rawData: this.state.rawData,
                data: IncidentReportsData.data,
                type: "LineChart",
                multiLineChartAccessors: IncidentReportsData.chartAccessor,
                accessor: IncidentReportsData.chartAccessor.mainAccessor,
                colors: IncidentReportsData.colors,
                yAxisLabel: "Count",
                XAxisLabel: "Day wise Data"
              }}
              legends={IncidentReportsData.legends}
            />
          ) : (
            <Skeleton
              animation={"wave"}
              variant={"rect"}
              width={"100%"}
              height={"100%"}
            />
          )}
        </div>
        {IsConditionOpen && (
          <Dialog
            maxWidth={"md"}
            open={IsConditionOpen}
            onClose={() =>
              this.setState({ IsConditionOpen: false, FiltersView: false })}
            PaperComponent={PaperComponent}
            aria-labelledby={"responsive-dialog-title"}
            fullScreen={!FiltersView}
          >
            <AppBar
              style={{ position: "relative", backgroundColor: "#064473" }}
            >
              <Toolbar>
                <Typography variant={"h6"} style={{ flex: "1" }}>
                  <DialogTitle
                    style={{ cursor: "move" }}
                    id={"responsive-dialog-title"}
                    className={"white-label"}
                  >
                    {this.props.conf == 1
                      ? "Operational Incidents"
                      : this.props.conf == 2
                      ? "Health & Safety / Near Miss"
                      : "Guard-Force Patrols"}
                    <span className={"condition-label white-label"}>
                      {"(Applied filters)\r"}
                    </span>
                  </DialogTitle>
                </Typography>
                <Tooltip title={"Close"}>
                  <IconButton
                    edge={"end"}
                    color={"inherit"}
                    onClick={() => {
                      this.setState({
                        IsConditionOpen: false,
                        FiltersView: false
                      });
                    }}
                    aria-label={"close"}
                    className={"white-button"}
                  >
                    <IoMdCloseCircleOutline />
                  </IconButton>
                </Tooltip>
              </Toolbar>
            </AppBar>
            <DialogContent>
              <DialogContentText>
                {FiltersView ? (
                  settingContainer.columns &&
                  settingContainer.columns.map(item => (
                    <div className={"col-xs-12"}>
                      <div className={"col-xs-12 start-xs condition-heading"}>
                        <b>{item.name}</b>{" "}
                      </div>
                      <div>
                        <div className={"col-xs-11 condition-label"}>
                          {"Received Date: From "}{this.props.startDate}{" To"}{" "}
                          {this.props.endDate}
                        </div>
                        <div className={"col-xs-11 condition-label"}>
                          {"Job Type: "}{item.filters[0].values.join()}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <>
                    <div>
                      {SortedRawData.map(item => (
                        <>
                          <div>
                            <h3>{item.title}</h3>
                          </div>
                          <hr />
                          <DenseTable
                            columns={CData}
                            data={item.type}
                            config={{
                              minRows: 10
                            }}
                          />
                        </>
                      ))}
                    </div>
                  </>
                )}
                {FiltersView ? (
                  <span className={"data-sync-text"}>
                    {/* {localStorage.getItem("syncStatus")} */}
                    {getSynchStatus(this.state.syncStatus)}
                  </span>
                ) : null}
              </DialogContentText>
            </DialogContent>
          </Dialog>
        )}
      </>
    );
  }
}

export default HealthAndSeftyGrphChart;
